import React from 'react';
import { AlertTriangle, X, Trash2 } from 'lucide-react';

const ForceDeleteModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = "Force Delete",
  entityName, 
  entityType = "item",
  productCount, 
  isLoading = false 
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white dark:bg-gray-800 rounded-lg max-w-md w-full p-6 shadow-xl">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3">
            <AlertTriangle className="h-6 w-6 text-orange-500" />
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
              {title}
            </h3>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        
        <div className="mb-6">
          <p className="text-gray-600 dark:text-gray-300 mb-4">
            The {entityType} <strong>"{entityName}"</strong> cannot be deleted because it has <strong>{productCount} active product{productCount > 1 ? 's' : ''}</strong> associated with it.
          </p>
          
          <div className="bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-800 rounded-lg p-4 mb-4">
            <p className="text-sm text-orange-800 dark:text-orange-200">
              To delete this {entityType}, you need to:
            </p>
            <ul className="text-sm text-orange-700 dark:text-orange-300 mt-2 space-y-1">
              <li>• Move all products to another {entityType}, or</li>
              <li>• Delete all products first, or</li>
              <li>• Use force delete (admin only)</li>
            </ul>
          </div>
          
          <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4">
            <p className="text-sm text-red-800 dark:text-red-200 mb-2">
              <strong>Force Delete Option:</strong>
            </p>
            <p className="text-sm text-red-700 dark:text-red-300">
              You can force delete this {entityType} which will also delete all {productCount} associated products. This action cannot be undone.
            </p>
          </div>
        </div>
        
        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            disabled={isLoading}
            className="px-4 py-2 text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 font-medium transition-colors"
          >
            Cancel
          </button>
          
          <button
            onClick={onConfirm}
            disabled={isLoading}
            className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white font-medium rounded-lg transition-colors flex items-center gap-2"
          >
            <Trash2 className="h-4 w-4" />
            {isLoading ? 'Deleting...' : 'Force Delete'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ForceDeleteModal;